import { Injectable } from "@angular/core";
import { AngularFirestore, DocumentChangeAction, DocumentReference } from "@angular/fire/firestore";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})

export class FirestoreService {
    constructor(private readonly firestore: AngularFirestore) { }

    getDocument(collectionName: string): Observable<Array<DocumentChangeAction<{}>>> {
        return this.firestore.collection(collectionName)
            .snapshotChanges();
    }

    getDocumentWithCondition(collectionName: string, objectKey: string, objectValue: any): Observable<Array<DocumentChangeAction<{}>>> {
        return this.firestore.collection(collectionName, ref => ref.where(objectKey, "==", objectValue))
            .snapshotChanges();
    }

    async createDocument<T>(typeObj: T, collectionName: string): Promise<DocumentReference> {
        return this.firestore.collection(collectionName)
            .add(typeObj);
    }

    async updateDocument<T>(typeObj: T, collectionName: string, documentId: string): Promise<void> {
        return this.firestore.doc(`${collectionName}/${documentId}`)
            .update(typeObj);
    }

    async deleteDocument(collectionName: string, policyId: string): Promise<void> {
        return this.firestore.doc(`${collectionName}/${policyId}`)
            .delete();
    }
}
